export default __webpack_public_path__ + "static/media/project16.bbb31742.png";